import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Util } from '@shared/common/utils/util';

export interface TrabajosPesadosRequest {
  rut: string;
  dateIni: string;
  dateFin: string;
}

export interface TrabajosPesadosResponse {
  status: number;
  message: string;
  data: {
    totalRebaja: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  constructor(
    private readonly http: HttpClient,
    private readonly util: Util
  ) { }

  public async obtenerTrabajosPesados(
    payload: TrabajosPesadosRequest
  ): Promise<TrabajosPesadosResponse> {
    const token = await this.util.getIdToken();
    const headers = this.util.getHeaders(token);
    const url = `${environment.BASE_BACKEND}/certificados/trabajos-pesados`;

    return firstValueFrom(
      this.http.post<TrabajosPesadosResponse>(url, payload, { headers })
    );
  }
}

